export const WEIGHT_STEP = 1
export const PRICE_STEP = 0.01

export const MAX_UNASSIGNED_COUNTRIES = 15
